Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

function updateCart() {
    $.ajax({
        url: '/cart?view=cw-slide-cart',
        dataType: 'HTML',
        method: "GET",
        success: function(htmlData) {
            let html_markup = $(htmlData);
            let to_replace = $(htmlData).find('#cw-cart').html();
            console.log(to_replace);

            $('#cw-cart').html(to_replace);


            $('.drawer').addClass('active');
            $('.drawer').removeClass('is-empty');
            if ($('.js-pro-list').length < 1) {
                console.log('test')
                $('.customization-popup__heading').hide();
                $('.may-like-productlist').hide();
            } else {
                $(".customization-popup__body").css("overflow-y", "auto");
            }

            $.get('/cart.json', function(cart) {
                $('.count-cart').text(cart.item_count);


            });

        }
    });
}

function cartPageUpdate() {
    $.ajax({
        url: '/cart?view=cart',
        dataType: 'HTML',
        method: "GET",
        success: function(htmlData) {
            let html_markup = $(htmlData);
            let to_replace = $(htmlData).find('#cw-cart1').html();
            console.log(to_replace);

            $('#cw-cart1').html(to_replace);


            $('.drawer').addClass('active');
            $('.drawer').removeClass('is-empty');
            if ($('.js-pro-list').length < 1) {
                console.log('test')
                $('.customization-popup__heading').hide();
                $('.may-like-productlist').hide();
            } else {
                $(".customization-popup__body").css("overflow-y", "auto");
            }

            $.get('/cart.json', function(cart) {
                $('.js-count-cart').text(cart.item_count);


            });

        }
    });
}

$(document).ready(function() {
    $(".bold-ro__one-time-purchase").html("<span class='new_view_design'><span class='title-text'>One Time Purchase</span><span class='currency money'></span></span>");

    console.log("ready!");
    // Increase Decrease Count 

    $(document).on('click', '.quantity .plus', function(e) {
        let $input = $(this).prev('input.qty');
        let val = parseInt($input.val());
        $input.val(val + 1).change();
    });

    $(document).on('click', '.quantity .minus', function(e) {

        let $input = $(this).next('input.qty');
        var val = parseInt($input.val());
        if (val > 1 ) {
            $input.val(val - 1).change();
            console.log("object if", val);
        }else{
            console.log("object else");
        }
    });
    $(document).on('click', '.js-pdp-atc', function(e) {
        let vid = $(this).attr('data-id');
        let qty = $('.js_pdp_qty').val();
        $.ajax({
            "url": "/cart/add.js",
            "method": "POST",
            "dataType": "JSON",
            "data": {
                id: vid,
                quantity: qty
            },
            "success": function(data) {
                //window.location = "/cart";
                updateCart();
                $(".slide-cart").addClass("open-slide-cart");
                $("body").addClass("opacity-body");
                $("html").addClass("hide-scroll-body");
                // $('.customization-popup').addClass('is-visible');

            },
            "error": function(data) {
                window.alert(data.responseJSON.description);
            }
        });
    });
    $(document).on('click', '.slide-cart-close', function(e) {
        updateCart();
        $(".slide-cart").removeClass("open-slide-cart");
        $("body").removeClass("opacity-body");
        $("html").removeClass("hide-scroll-body");
    });
    $(document).on('click', '.js-product-quantity-remove', function(e) {
        e.preventDefault();
        let current_em = $(e.target);
        let key = $(this).attr('data-key');

        let updated_qty = 0;
        let current_item = {};
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                updateCart();
            },
            error: function(error) {
                console.log(error)
            }
        });
    });
    $(document).on('click', '.js-product-cartquantity-remove', function(e) {
        e.preventDefault();
        let current_em = $(e.target);
        let key = $(this).attr('data-key');

        let updated_qty = 0;
        let current_item = {};
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                cartPageUpdate();
            },
            error: function(error) {
                console.log(error)
            }
        });
    });


    $(document).on('click', '.js_qtyplus', function(e) {
        console.log('value change');
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) + 1;
        let current_item = {};
        let key = $(parent).attr('data-key');
        console.log(key)
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                console.log('got here called');
                updateCart();

            },
            error: function(error) {
                console.log(error)
            }
        });
    });
    $(document).on('click', '.js_cartqtyplus', function(e) {
        console.log('value change');
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) + 1;
        let current_item = {};
        let key = $(parent).attr('data-key');
        console.log(key)
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                console.log('got here called');
                cartPageUpdate();

            },
            error: function(error) {
                console.log(error)
            }
        });
    });

    $(document).on('click', '.js_qtyminus', function(e) {
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) - 1;
        let current_item = {};
        if (updated_qty <= 0) {
            updated_qty = 0;
        }
        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                updateCart();

            },
            error: function(error) {
                console.log(error)
            }
        });
    });
    $(document).on('click', '.js_cartqtyminus', function(e) {
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) - 1;
        let current_item = {};
        if (updated_qty <= 0) {
            updated_qty = 0;
        }
        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                cartPageUpdate();

            },
            error: function(error) {
                console.log(error)
            }
        });
    });

    $(document).on('change', `.js-cw-product-page-form [data-option-1] input, .js-cw-product-page-form [data-option-2] input,.js-cw-product-page-form [data-option-3] input`, function(e) {

        let option1 = option2 = option3 = null;
        if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
            option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();

        }
        if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
            option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
        }
        if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
            option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
        }
        let variant_id = null;
        let current_selected_option = null;
        if (option2 == null & option3 == null) {

            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
        }
        if (option2 != null & option3 == null) {

            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
        }
        if (option2 != null & option3 != null) {

            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        }
        if (variant_id == null) {
            $(`.js-cw-product-page-form .stock`).fadeOut(100);
            $(`.js-cw-product-page-form .js-out-stock`).fadeIn(100);
            $(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
            $(`.js-cw-product-page-form .product_page_atc span`).text("Unavailable");
            return true;
        }
        let price = $(current_selected_option).attr('data-price');
        let compare_at_price = $(current_selected_option).attr('data-compareat-price');
        let discount = $(current_selected_option).attr('data-discount');
        let image_src = $(current_selected_option).attr('data-image');
        console.log(image_src);
        let save = $(current_selected_option).attr('data-save');
        let is_available = $(current_selected_option).attr('data-available');
        $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');

        $(`.js-price`).text(price);
        if (compare_at_price > price) {
            $('.js_was_price').html('Was ' + compare_at_price);
        } else {
            $('.js_was_price').html('');
        }

        $(`.js-cw-product-page-form .js_discount`).text('Save ' + discount + '%');
        if (is_available == 'true') {
            $(`.js-cw-product-page-form .stock`).fadeIn(100);
            $(`.js-cw-product-page-form .js-out-stock`).fadeOut(100);
            $('.available_btn .circle p').text('Available Now!');
            $(`.js-pdp-atc`).removeClass('soldout');
            $(`.js-pdp-atc`).html('Add to Cart <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.8604 6L17.3699 7.393L25.2708 15H4.26758V17H25.2708L17.3699 24.573L18.8604 26L29.2839 16L18.8604 6Z" fill="white" stroke="white"></path> </svg>');

        } else {
            $(`.js-cw-product-page-form .stock`).fadeOut(100);
            $(`.js-cw-product-page-form .js-out-stock`).fadeIn(100);
            $(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
            $(`.js-pdp-atc`).text("Soldout");
            $('.available_btn .circle p').text('Sold Out');
        }
        // let current_position = null;
        // cw.variants.forEach((em,ix) => {
        // 	if( em.id == variant_id && em.featured_image != null ) {
        // 		current_position = em.featured_image.position - 1;
        // 		$(`.probig.slider-for`).slick('slickGoTo',current_position);
        // 	}
        // });
        var newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            variant_id;
        window.history.replaceState({
            path: newurl
        }, '', newurl);

        setTimeout(function() {}, 2000);
        let boldDiscount = $(".bold-ro__initial-discount-percent").html().substring(0);
        console.log(boldDiscount)
        let x = boldDiscount.substring(0, boldDiscount.length - 1);
        console.log(x)
        let productSubPrice = $(current_selected_option).attr('data-sub-price');
        let disPrice = (productSubPrice * 5) / 100;
        let finalSubscritpionPrice = productSubPrice - disPrice;
        console.log(Shopify.formatMoney(disPrice, $('body').attr('data-money-format')));
        $('.bold-ro__initial-discount-price').html(Shopify.formatMoney(finalSubscritpionPrice, $('body').attr('data-money-format')));

    });



    $(document).on(`click`, `.js-pdp-atc`, function(e) {
        e.preventDefault();
        let items = Array();
        let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
        let item = {};
        form_data_array.forEach((em, ix) => {
            item[em.name] = em.value;
        });
        items.push(item);
        $(`.js-cw-product-page-form .cw-upsells:checked`).each(function(ix, em) {
            let upsell_item = {};
            upsell_item.id = $(em).val();
            upsell_item.quantity = 1;
            items.push(upsell_item);
        });
        $.ajax({
            url: "/cart/add.js",
            data: {
                items: items
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                updateCart();
            },
            error: function(data) {
                window.alert(data.responseJSON.description);
            }
        });
    });
    setTimeout(function() {
        let boldDiscount = $(".bold-ro__initial-discount-percent").html().substring(0);
        console.log(boldDiscount)
        let x = boldDiscount.substring(0, boldDiscount.length - 1);
        console.log(x)
        let discount = $('.product-price span:first').text();
        console.log(discount)

    }, 2000);
    $('.filter-menu__detail h6').matchHeight({
        byRow: 0,
    });
    $('.filter-menu__detail .filter-menu__rating').matchHeight({
        byRow: 0,
    });
    $(document).on(`click`, `.js_filter_checkbox`, function(e) {
        console.log($('.js_filter_checkbox:checked').length);
        if ($('.js_filter_checkbox:checked').length == 0) {
            $('#default_check').click()
        }
        let colhandle = $(this).attr('data-handle');
        let thisValue = $(this).val();
        var criteria = $("#sort-by option:selected").attr('data-val');


        //console.log("triggered");


        $('#proshow').html('');

        $('.js_filter_checkbox:checked').each(function(index, element) {
            colhandle = $(element).attr('data-handle');
            $('[loader]').removeClass('js_hide');
            $("body").addClass("gif-loader-show");
            $(".filter-menu .container > .row").hide();
            if ($("body").hasClass("gif-loader-show")) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".filter-menu__right").offset().top
                }, 10);
            }
            $.ajax({
                url: "/collections/" + colhandle,
                method: "GET",
                dataType: "HTML",

                success: function(htmlData) {
                    
                    let html_markup = $(htmlData);
                    let to_replace = $(htmlData).find('#proshow').html();
                    console.log(to_replace)
                    
                    $('#proshow').append(to_replace);
                    $('[loader]').addClass('js_hide');
                    $("body").removeClass("gif-loader-show");
                    $(".filter-menu .container > .row").show();

                    // load more data
                    let getwindowsize = $(window).width();
                    if (getwindowsize < 992) {
                        $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                    }
                    // end load more data
                    $('.filter-menu__detail h6').matchHeight({
                        byRow: 0,
                    });
                    $('.filter-menu__detail .filter-menu__rating').matchHeight({
                        byRow: 0,
                    });
                setTimeout(function () {
                    if($('#proshow .grid-item').length == 0){
                      
                        $('.no_data_found').removeClass('js_hide');
                       // $('#proshow').remove();
                    }else{
                        $('.no_data_found').addClass('js_hide');
                    }
                }, 500);
                },
                error: function(data) {
                    window.alert(data.responseJSON.description);
                }
                
            });
            
        });
        
    });

    // $(document).on('change', '#sort-by', function(e) {
    //     var colhandle = $('.js_filter_checkbox:checked').attr('data-handle');
    //     var criteria = this.value;

    //     $('#proshow').html('');
    //     $('.js_filter_checkbox:checked').each(function(index, element) {
    //         colhandle = $(element).attr('data-handle');
    //         $.ajax({
    //             url: '/collections/' + colhandle + '?sort_by=' + criteria,
    //             type: 'GET',
    //             success: function(htmlData) {
    //                 let html_markup = $(htmlData);
    //                 let to_replace = $(htmlData).find('#proshow').html();
    //                 console.log(to_replace);
    //                 // alert('datashow')
    //                 //$('#proshow').html(to_replace);
    //                 $('#proshow').append(to_replace);
    //                 $('[loader]').addClass('js_hide');
    //                 $("body").removeClass("gif-loader-show");

    //             }
    //         });
    //     });
    // });
    $(document).on("change", ".js-form-control", function() {
        var sortingMethod = $(this).val();
    
        if (sortingMethod == 'l2h') {
            $('[loader]').removeClass('js_hide');
            $("body").addClass("gif-loader-show");
            $(".filter-menu .container > .row").hide();
            if ($("body").hasClass("gif-loader-show")) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".filter-menu__right").offset().top
                }, 10);
            }
            $('.grid-item').hide();
            setTimeout(function() {
                $('[loader]').addClass('js_hide');
                $("body").removeClass("gif-loader-show");
                $(".filter-menu .container > .row").show();
    
                // load more data
                let getwindowsize = $(window).width();
                if (getwindowsize < 992) {
                    $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                }
                // end load more data
                $('.filter-menu__detail h6').matchHeight({
                    byRow: 0,
                });
                $('.filter-menu__detail .filter-menu__rating').matchHeight({
                    byRow: 0,
                });
    
                sortProductsPriceAscending();
                $('.grid-item').show();
            }, 1000);
        } else if (sortingMethod == 'h2l') {
            $('[loader]').removeClass('js_hide');
            $("body").addClass("gif-loader-show");
            $(".filter-menu .container > .row").hide();
            if ($("body").hasClass("gif-loader-show")) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".filter-menu__right").offset().top
                }, 10);
            }
            $('.grid-item').hide();
            setTimeout(function() {
                $('[loader]').addClass('js_hide');
                $("body").removeClass("gif-loader-show");
                $(".filter-menu .container > .row").show();
    
                // load more data
                let getwindowsize = $(window).width();
                if (getwindowsize < 992) {
                    $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                }
                // end load more data
                $('.filter-menu__detail h6').matchHeight({
                    byRow: 0,
                });
                $('.filter-menu__detail .filter-menu__rating').matchHeight({
                    byRow: 0,
                });
                sortProductsPriceDescending();
                $('.grid-item').show();
            }, 1000);
        } else if (sortingMethod == 'a2z') {
            $('[loader]').removeClass('js_hide');
            $("body").addClass("gif-loader-show");
            $(".filter-menu .container > .row").hide();
            if ($("body").hasClass("gif-loader-show")) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".filter-menu__right").offset().top
                }, 10);
            }
            $('.grid-item').hide();
            setTimeout(function() {
                $('[loader]').addClass('js_hide');
                $("body").removeClass("gif-loader-show");
                $(".filter-menu .container > .row").show();
    
                // load more data
                let getwindowsize = $(window).width();
                if (getwindowsize < 992) {
                    $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                }
                // end load more data
                $('.filter-menu__detail h6').matchHeight({
                    byRow: 0,
                });
                $('.filter-menu__detail .filter-menu__rating').matchHeight({
                    byRow: 0,
                });
                sortAscendingProducts();
                $('.grid-item').show();
            }, 1000);
        } else if (sortingMethod == 'z2a') {
            $('[loader]').removeClass('js_hide');
            $("body").addClass("gif-loader-show");
            $(".filter-menu .container > .row").hide();
            if ($("body").hasClass("gif-loader-show")) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".filter-menu__right").offset().top
                }, 10);
            }
            $('.grid-item').hide();
            setTimeout(function() {
                $('[loader]').addClass('js_hide');
                $("body").removeClass("gif-loader-show");
                $(".filter-menu .container > .row").show();
    
                // load more data
                let getwindowsize = $(window).width();
                if (getwindowsize < 992) {
                    $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                }
                // end load more data
                $('.filter-menu__detail h6').matchHeight({
                    byRow: 0,
                });
                $('.filter-menu__detail .filter-menu__rating').matchHeight({
                    byRow: 0,
                });
                sortDescendingProducts();
                $('.grid-item').show();
            }, 1000);
        } else {
            otherSort();
        }
    });
    
    function sortProductsPriceAscending() {
        var gridItems = $('.grid-item');
    
        gridItems.sort(function(a, b) {
            return $('.product-card', a).data("price") - $('.product-card', b).data("price");
        });
        console.log(gridItems);
        $("#proshow").append(gridItems);
    }
    
    function sortProductsPriceDescending() {
        var gridItems = $('.grid-item');
    
        gridItems.sort(function(a, b) {
            return $('.product-card', b).data("price") - $('.product-card', a).data("price");
        });
        console.log(gridItems);
        $("#proshow").append(gridItems);
    }
    
    function sortAscendingProducts() {
        var gridItems = $('.grid-item');
        var myThis = $(this);
        var item = $('.row');
        var itemSort = $('.grid-item', item);
    
        itemSort.sort(function(a, b) {
            var checkA = $(a).attr('data-title');
            var checkB = $(b).attr('data-title');
            //  console.log(checkA)
            //Covert to lowercase for checking letters.
    
            lowerCaseA = checkA.toLowerCase();
            lowerCaseB = checkB.toLowerCase();
    
            //Check what button was clicked
            return (lowerCaseA > lowerCaseB) ? 1 : (lowerCaseA < lowerCaseB) ? -1 : 0;
            //   if(myThis.hasClass('ac')){
    
            //    // ascending sort
    
            //   }else if(myThis.hasClass('dec')){ 
    
            //    return (lowerCaseA < lowerCaseB) ? 1 :  (lowerCaseA > lowerCaseB) ? -1 : 0; // descending sort
    
            //   }else{
    
            //     return Math.random()*10 > 5 ? 1 : -1; // random sort
            //   }
    
        });
        //loop through items
        $.each(itemSort, function(index, val) {
    
            $("#proshow").append(val);
    
        });
    
    
    
    
    }
    
    function sortDescendingProducts() {
        var gridItems = $('.grid-item');
        var myThis = $(this);
        var item = $('.row');
        var itemSort = $('.grid-item', item);
    
        itemSort.sort(function(a, b) {
            var checkA = $(a).attr('data-title');
            var checkB = $(b).attr('data-title');
            console.log(checkA)
            //Covert to lowercase for checking letters.
    
            lowerCaseA = checkA.toLowerCase();
            lowerCaseB = checkB.toLowerCase();
    
            //Check what button was clicked
            return (lowerCaseA < lowerCaseB) ? 1 : (lowerCaseA > lowerCaseB) ? -1 : 0;
    
        });
        //loop through items
        $.each(itemSort, function(index, val) {
    
            $("#proshow").append(val);
    
        });
    }
    
    function otherSort() {
        var colhandle = $('.js_filter_checkbox:checked').attr('data-handle');
        var criteria = $('.js-form-control').val();
        $('[loader]').removeClass('js_hide');
        $("body").addClass("gif-loader-show");
        $(".filter-menu .container > .row").hide();

        if ($("body").hasClass("gif-loader-show")) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".filter-menu__right").offset().top
            }, 10);
        }
        $('#proshow').html('');
        $('.js_filter_checkbox:checked').each(function(index, element) {
            colhandle = $(element).attr('data-handle');
            $.ajax({
                url: '/collections/' + colhandle + '?sort_by=' + criteria,
                type: 'GET',
                success: function(htmlData) {
                    let html_markup = $(htmlData);
                    let to_replace = $(htmlData).find('#proshow').html();
                    console.log(to_replace);
                    // alert('datashow')
                    //$('#proshow').html(to_replace);
                    $('#proshow').append(to_replace);
                    $('[loader]').addClass('js_hide');
                    $("body").removeClass("gif-loader-show");
                    $(".filter-menu .container > .row").show();

                    // load more data
                    let getwindowsize = $(window).width();
                    if (getwindowsize < 992) {
                        $(".filter-menu__right .filter-menu__items").slice(0, 4).show();
                    }
                    // end load more data
                    $('.filter-menu__detail h6').matchHeight({
                        byRow: 0,
                    });
                    $('.filter-menu__detail .filter-menu__rating').matchHeight({
                        byRow: 0,
                    });
    
                }
            });
        });
    }
    $(document).on("click", "#clear-filter", function() {
         
        $('.js_filter_checkbox').prop('checked', false);
        $('#default_check').click();
    });
   
    $(document).on("click", ".moreless-button", function() {
        // $('.moretext').slideToggle();
        // if ($('.moreless-button').text() == "Read more") {
        //     $('.js-trunc-word').hide();
        //   $(this).text("Read less")

        // } else {
        //     $('.js-trunc-word').show();
        //   $(this).text("Read more")
        // }
            $(".product-detail__description").toggleClass("full-detail-show");
            if($(this).text() == "Read more"){
                $(this).text("Read less");
            }else {
                $(this).text("Read more");
                $('html, body').animate({
                    scrollTop: $(".product-detail__description").offset().top - 50
                }, 800);
            }
      });
      $(document).on("click", ".mobile-moreless-button", function() {
        // $('.mobile-moretext').slideToggle();
        // if ($('.mobile-moreless-button').text() == "Read more") {
        //     $('.js-mobile-desc').hide();
        //   $(this).text("Read less")

        // } else {
        //     $('.js-mobile-desc').show();
        //   $(this).text("Read more")
        // }
            $(".mobaile_desc.js-mobile-desc").toggleClass("full-detail-show");
            if($(this).text() == "Read more"){
                $(this).text("Read less");
                $(this).css("color", "var(--primary)");
            }else {
                $(this).text("Read more");
                $(this).css("color", "var(--secondary)");
                $('html, body').animate({
                    scrollTop: $(".mobaile_desc.js-mobile-desc").offset().top - 50
                }, 800);
            }
      });

    $('.js-radio').trigger('change')
});